module.exports = __webpack_public_path__ + "static/media/Vert Logo.bd02fada.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/Vert Logo.svg
// module id = 1007
// module chunks = 388